import React, { FC, useCallback, useEffect } from 'react';
import { launchAsync } from '@microsoft/immersive-reader-sdk';
import { useFetch } from '../../hooks';
import apiRoutes from '../../../../config/api/routes';
import { getMicrosoftMapper } from '../../../../config/api/models';
import { IconButton } from '../buttons';
import { Icons } from '../SvgIcon';
import { LogActionTypes, useDataLogging } from '../../data-logging';
import { styled, useTheme } from '@material-ui/core';

type Props = {
  title?: string;
  content: string;
};

const StyledIconButton = styled(IconButton)({
  margin: '-2rem 0 0 -1rem',
});

const ImmersiveReaderButton: FC<Props> = ({ title, content }) => {
  const theme = useTheme();
  const log = useDataLogging();

  const [fetchMicrosoftTokenResponse, fetchMicrosoftToken] = useFetch(apiRoutes.microsoftToken(), {
    method: 'GET',
    mapper: getMicrosoftMapper,
  });

  const getTokenAndLaunch = useCallback(() => {
    if (fetchMicrosoftTokenResponse.initial) fetchMicrosoftToken();

    if (fetchMicrosoftTokenResponse.success && !!fetchMicrosoftTokenResponse.data) {
      const token = fetchMicrosoftTokenResponse.data.accessToken;
      const subdomain = fetchMicrosoftTokenResponse.data.subdomain;
      const blockContent = {
        title,
        chunks: [
          {
            content,
            lang: 'nl-be',
            mimeType: 'text/html',
          },
        ],
      };
      launchAsync(token, subdomain, blockContent, {
        uiZIndex: 9999,
        uiLang: 'nl-BE',
      }).catch((error: any) => {
        log(LogActionTypes.ERROR, { message: 'Error in launching the Immersive Reader.', error });
      });
    }
  }, [fetchMicrosoftTokenResponse, fetchMicrosoftToken, title, content, log]);

  useEffect(() => {
    if (fetchMicrosoftTokenResponse.success) {
      getTokenAndLaunch();
    }
  }, [fetchMicrosoftTokenResponse.success, getTokenAndLaunch]);

  return (
    <StyledIconButton
      large
      icon={Icons.IMMERSIVE_READER}
      color={theme.palette.text.primary}
      onClick={getTokenAndLaunch}
      className="hide-on-print"
    />
  );
};

export default ImmersiveReaderButton;
